export const DEFAULT_LOCALE = 'en-US';
const ASH_TRIM_PREFIX = 'ashtrim';
export const FOOTER_NAV_ITEMS_UPDATED_EVENT_NAME = `${ASH_TRIM_PREFIX}-footer-nav-items-updated`;
export const HEADER_NAV_ITEMS_LOCAL_STORAGE_KEY = `${ASH_TRIM_PREFIX}-header-nav-menu`;
export const FOOTER_NAV_ITEMS_LOCAL_STORAGE_KEY = `${ASH_TRIM_PREFIX}-footer-nav-menu`;
export const ASX_USER_LOCALE = `${ASH_TRIM_PREFIX}-locale-code`;

// Weblabs
export const ASX_REBRANDING = 'ASX_REBRANDING_1271116';

// Styling/CSS Values
export const LINK_CLASS = 'asx-link-text';
